// 屏幕比例相关类型
export const PAGE_RATIO = {
  RATIO_16_9: '16/9',
  RATIO_9_16: '9/16',
  RATIO_1_1: '1/1',
  RATIO_4_3: '4/3',
  RATIO_3_4: '3/4'
} as const;

export type PageRatioType = (typeof PAGE_RATIO)[keyof typeof PAGE_RATIO];

// 默认画布宽高
export const DEFAULT_CANVAS_W: number = 1920;
export const DEFAULT_CANVAS_H: number = 1080;

export const CANVAS_MARGIN: number = 40;

//默认水印设置
export const DEFAULT_ENABLE_WATERMARK = true;

/** 单页默认播放时长（毫秒），源数据没有时长信息，先用固定值占位 */
export const DEFAULT_PAGE_DURATION: number = 2000;

/** TTS 音频播放前的停顿时长（秒） */
export const TTS_AUDIO_LEADING_PAUSE_DURATION: number = 0.7;

/** TTS 音频播放后的停顿时长（秒） */
export const TTS_AUDIO_TRAILING_PAUSE_DURATION: number = 0.7;

export const LAYOUT_TYPE = {
  // 全屏图片
  FULL_SCREEN: 'full_image_16_9',
  // 跨页双画（1:1）
  CROSS_PAGE_11: 'cross_page_1_1',
  // 跨页双画（3:4）
  CROSS_PAGE_34: 'cross_page_3_4',
  // 上图下文（1:1）
  IMAGE_TEXT_11: 'image_text_v_1_1',
  // 左文右图
  TEXT_IMAGE_34: 'text_image_h_3_4',
  // 上图下文（3:4）
  IMAGE_TEXT_34: 'image_text_v_3_4'
} as const;

export type LayoutType = (typeof LAYOUT_TYPE)[keyof typeof LAYOUT_TYPE];

// 画布内容的label
export const CANVAS_LABEL = {
  ROOT_CONTAINER: 'root-container',
  BACKGROUND_CONTAINER: 'background-container',
  ELEMENT_CONTAINER: 'element-container',
  CAPTION_CONTAINER: 'caption-container',
  GUIDE_LINE: 'guide-Line',
  TRANSFORMER: 'transformer',
  BACKGROUND: 'background',
  ELEMENT: 'element',
  CAPTION: 'caption'
} as const;

// action 相关类型
export const ACTION_TYPE = {
  DEFAULT: 'default',
  BACKGROUND: 'background',
  MEDIA: 'media',
  TEXT: 'text',
  CAPTION: 'caption',
  SOUND: 'sound',
  EVENT: 'event'
} as const;

export type ActionType = (typeof ACTION_TYPE)[keyof typeof ACTION_TYPE];

// 元素相关类型
export const ELEMENT_TYPE = {
  DEFAULT: 'default',
  BACKGROUND: 'background',
  SHAPE: 'shape',
  IMAGE: 'image',
  GIF: 'gif',
  VIDEO: 'video',
  TEXT: 'text',
  CAPTION: 'caption',
  SOUND: 'sound',
  EVENT: 'event'
} as const;

export type ElementType = (typeof ELEMENT_TYPE)[keyof typeof ELEMENT_TYPE];

// 动画相关类型
export const MOTION_TYPE = {
  ENTER: 'enter',
  EMPHASIS: 'emphasis',
  EXIT: 'exit'
} as const;

export type MotionType = (typeof MOTION_TYPE)[keyof typeof MOTION_TYPE];

// 背景元素相关类型
export const BACKGROUND_TYPE = {
  COLOR: 'color',
  IMAGE: 'image',
  VIDEO: 'video'
} as const;

export type BackgroundType = (typeof BACKGROUND_TYPE)[keyof typeof BACKGROUND_TYPE];

// 颜色相关类型
export const COLOR_TYPE = {
  PURE: 'pure',
  LINEAR: 'linear',
  RADIAL: 'radial'
} as const;

export type ColorType = (typeof COLOR_TYPE)[keyof typeof COLOR_TYPE];

export const DEFAULT_BACKGROUND_COLOR = '#F8FAFC';

/** 阅读端画布 PC 背景色（与 BookReader 一致） */
export const CANVAS_PC_BACKGROUND = 0xf8fafc;

/** 阅读端画布移动端背景色 */
export const CANVAS_MOBILE_BACKGROUND = 0x000000;

/** 阅读端画布移动端断点（与 BookReader / BookLoading 一致） */
export const CANVAS_MOBILE_BREAKPOINT = 720;
